import Vue from 'vue';

import jwtService from "@/plugins/jwtService";
import ApiService from "@/plugins/ApiService";
import Gate from "@/plugins/Gate";
import * as Mutations from "@/store/mutation-types";
import * as Actions from "@/store/action-types";



const state = {
    isLoggedIn: !!jwtService.getToken(),
    onLine: process.env.NODE_ENV === 'development' ? true : navigator.onLine,
    authUser: {},
    email: '',
}


const mutations = {

    [Mutations.SET_IS_ONLINE](state, online) {
        state.onLine = online;
    },


    [Mutations.SET_EMAIL](state, email) {
        state.email = email
    },

    [Mutations.CLEAR_AUTH_INFO](state) {
        jwtService.destroy();
        state.isLoggedIn = false
        this.authUser = {}
        Vue.prototype.$gate = {}
    },


    [Mutations.SET_AUTH_USER](state, user) {
        jwtService.saveUser(user)
        state.authUser = user
        Vue.prototype.$gate = new Gate(user);

    },


    [Mutations.SET_AUTH_INFO](state, data) {

        jwtService.saveUser(data.user)
        jwtService.saveToken(data.access_token)
        state.authUser = data.user
        state.isLoggedIn = true
        Vue.prototype.$gate = new Gate(data.user);
    },

}

const getters = {
    isVerified(state) {
        return state.authUser.emailVerifiedAt !== null
    }
}


const actions = {

    [Actions.RESET_PASSWORD]({ commit }, credentials) {
        commit(Mutations.SET_LOADING, true)

        return new Promise((resolve, reject) => {

            ApiService.post('reset-password', credentials)
                .then(response => {
                    commit(Mutations.SET_LOADING, false)
                    commit(Mutations.SET_AUTH_INFO, response.data)
                    resolve(response.data)
                }).catch((e) => {
                    commit(Mutations.SET_LOADING, false)
                    reject(e)
                })
        })
    },

    [Actions.PASSWORD_EMAIL]({ commit }, credentials) {
        commit(Mutations.SET_LOADING, true)

        return new Promise((resolve, reject) => {

            ApiService.post('password-email', credentials)
                .then(response => {
                    commit(Mutations.SET_LOADING, false)
                    resolve(response.data)
                })
                .catch((e) => {
                    commit(Mutations.SET_LOADING, false)
                    reject(e)
                })
        })
    },

    [Actions.VERIFY_TOKEN]({ commit }, credentials) {
        commit(Mutations.SET_LOADING, true)

        return new Promise((resolve, reject) => {

            ApiService.post('verify-token', credentials)
                .then(response => {
                    resolve(response.data)
                    commit(Mutations.SET_LOADING, false)
                })
                .catch(() => {
                    commit(Mutations.SET_LOADING, false)
                    reject()
                })
        })
    },

    [Actions.RESEND_TOKEN]({ commit }, credentials) {
        commit(Mutations.SET_LOADING, true)

        return new Promise((resolve, reject) => {

            ApiService.post('/email/verify/resend', credentials)
                .then(response => {

                    resolve(response.data)
                    commit(Mutations.SET_LOADING, false)

                })
                .catch(() => {
                    commit(Mutations.SET_LOADING, false)
                    reject()
                })
        })
    },

    [Actions.REGISTER]({ commit }, credentials) {

        commit(Mutations.SET_LOADING, true)
        const route = credentials.provider ? 'social/register' : 'register'
        return new Promise((resolve, reject) => {

            ApiService.post(route, credentials)
                .then(response => {
                    commit(Mutations.SET_LOADING, false)
                    commit(Mutations.SET_AUTH_INFO, response.data)
                    resolve(response.data)
                })
                .catch(() => {
                    commit(Mutations.SET_LOADING, false)
                    reject()
                })
        })
    },

    [Actions.DISPATCH_LOGIN]({ commit }, credentials) {

        commit(Mutations.SET_LOADING, true)
        const route = credentials.provider ? 'social/login' : 'login'
        return new Promise((resolve, reject) => {
            ApiService.post(route, credentials)
                .then(response => {
                    commit(Mutations.SET_LOADING, false)
                    commit(Mutations.SET_AUTH_INFO, response.data)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(Mutations.SET_LOADING, false)
                    reject(e)
                })

        })
    },


    [Actions.DISPATCH_ADD_PHONE]({ commit }, credentials) {

        commit(Mutations.SET_LOADING, true)
        return new Promise((resolve, reject) => {
            ApiService.post('add-phone', credentials)
                .then(response => {
                    commit(Mutations.SET_LOADING, false)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(Mutations.SET_LOADING, false)
                    reject(e)
                })

        })
    },


    [Actions.FETCH_AUTH_INFO]({ commit, rootState }) {

        // if (jwtService.getUser()) {
        //     commit(Mutations.SET_AUTH_USER, jwtService.getUser())
        //     return
        // }

        return new Promise((resolve, reject) => {
            ApiService.get("user").then(({ data }) => {
                    commit(Mutations.SET_LOADING, false)
                    commit(Mutations.SET_AUTH_USER, data);

                    resolve(data)
                })
                .catch((e) => {
                    commit(Mutations.SET_LOADING, false)
                    reject(e)
                })


        })
    },

    [Actions.DISPATCH_LOGOUT]({ commit }) {
        return new Promise((resolve) => {
            commit(Mutations.CLEAR_AUTH_INFO)
            resolve()
        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}